// Lib
import React, { CSSProperties, RefObject } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { currentBoardHasMediaDownloadAccessSelector } from '../../../../../utils/permissions/elementPermissionsSelector';
import { isPresentationModeEnabledSelector } from '../../../../../workspace/presentation/presentationSelector';

// Components
import ImageModalV2PrimaryTools from './ImageModalV2PrimaryTools';

type ImageModalV2ToolbarProps = {
    isEditable: boolean;
    style?: CSSProperties;
    primaryToolbarRef?: RefObject<HTMLDivElement>;
};

const ImageModalV2Toolbar: React.FC<ImageModalV2ToolbarProps> = ({ isEditable, style, primaryToolbarRef }) => {
    const showDownloadOption = useSelector(currentBoardHasMediaDownloadAccessSelector);
    const isPresentationMode = useSelector(isPresentationModeEnabledSelector);

    return (
        <div
            className="ImageModalV2Toolbar absolute right-0 left-0 z-[2] h-12 w-full pointer-events-auto"
            style={style}
        >
            <div className="ImageModalV2Toolbar-animation-container w-full translate-y-0 transition-transform duration-200 [transition-timing-function:cubic-bezier(0.3,1,0.7,1)]">
                <div
                    ref={primaryToolbarRef}
                    className="ImageModalV2Toolbar-primary flex h-12 w-full items-center justify-center"
                >
                    <ImageModalV2PrimaryTools
                        isEditable={isEditable}
                        showDownloadOption={showDownloadOption}
                        isPresentationMode={isPresentationMode}
                    />
                </div>
            </div>
        </div>
    );
};

export default ImageModalV2Toolbar;
